// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zseF8Xt5pgpgQLagkRzp {
  display: block;
}

.CtlbL2WOkjYU3ouildAj {
  padding-top: 1.5rem;
  padding-bottom: 3rem;
}

.BzCKNWBZjBjcwtzDzoMz {
  margin-top: 6.5rem;
}

.kikIte92wCMFO0z_wwJG {
  margin-top: 2.5rem;
}

@media only screen and
  (max-width: 639px) {
  .BzCKNWBZjBjcwtzDzoMz {
    margin-top: 3.5rem;
  }

  .kikIte92wCMFO0z_wwJG {
    margin-top: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LandingPageBody/LandingPageBody.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAiB;AACnB;;AAEA;EACE,kBAAgB;AAClB;;AAEA;;EACE;IACE,kBAAgB;EAClB;;EAEA;IACE,kBAAgB;EAClB;AACF","sourcesContent":[".landingPageBody {\n  display: block;\n}\n\n.link {\n  padding-top: 24px;\n  padding-bottom: 48px;\n}\n\n.title {\n  margin-top: 104px;\n}\n\n.description {\n  margin-top: 40px;\n}\n\n@media (--mobile) {\n  .title {\n    margin-top: 56px;\n  }\n\n  .description {\n    margin-top: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"landingPageBody": `zseF8Xt5pgpgQLagkRzp`,
	"link": `CtlbL2WOkjYU3ouildAj`,
	"title": `BzCKNWBZjBjcwtzDzoMz`,
	"description": `kikIte92wCMFO0z_wwJG`
};
export default ___CSS_LOADER_EXPORT___;
